export enum LoginActionEnum {
  NavigateToProjects = 1,
  NavigateTo2fa = 2,
  NavigateToPasswordOrCode = 3,
  ExternalNavigation = 4,
  NavigateToLegalAgreements = 6,
  NavigateToSelectRole = 7,
  NavigateToRegistration = 8,
  NavigateToUpdatePassword = 9,
}
